module.exports = __webpack_public_path__ + "image-22d14e078665.png";